import * as React from "react";
import { useState, useEffect } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import {
  Box,
  Button,
  Grid,
  IconButton,
  ImageListItem,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

import NavBar from "../../../NavBar";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./styles.css";
import styled from "styled-components";
import { Controller, useForm } from "react-hook-form";
import editDriverScheme from "../../../validations/editDriverScheme";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  stateListDriverRequest,
  updateDriverRequest,
} from "../../../redux/driver/action";
import { useResponsive } from "../../../hooks/useResponsive";
import { useRef } from "react";
import MenuBar from "../../menuBar";
import { getDate, isMobileDeviceCheck } from "../../../utils";
import VehiclePlaceholderImage from "../../../assets/images/vehicle_placeholder.jpeg";
import { ReactComponent as UploadIcon } from "../../../assets/svg/uploaddoc.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svg/deleteFile.svg";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import { useTranslation } from "react-i18next";
import { COUNTRY_CODE } from "../../../utils/utils";
import { KEYS } from "../../../constants";

const EditDriver = ({ enableNav = true, isDialog = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { stateObject } = useSelector((state) => state.driverReducer);
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");
  const driverData = location.state;

  const updatedDriverData = {
    ...driverData,
    phoneNumber: driverData.phone.phoneNumber,
    countryCode: driverData.phone.intlDialCd,
  };

  const [isLoading, setIsLoading] = useState(false);

  const [uploadedImage, setUploadedImage] = useState();
  const [uploadInsuranceProof, setUploadInsuranceProof] = useState();
  const [uploadInsuranceProofImage, setUploadInsuranceProofImage] = useState();

  const [uploadedFile, setUploadedFile] = useState({
    type: updatedDriverData?.mediaTypeCode
      ? updatedDriverData?.mediaTypeCode
      : "",
  });
  const [isDrivingLicenseRemoved, setIsDrivingLicenseRemoved] = useState(false);
  const [isDriverInsuranceRemoved, setIsDriverInsuranceRemoved] =
    useState(false);
  const [dialogProps, setDialogProps] = useState({
    isOpen: false,
    title: `${t("pages.profile.key07")} ?`,
    content: `${t("pages.profile.key11")}`,
    reset: () => setDialogProps((prev) => ({ ...prev, isOpen: false })),
    handleContinue: undefined,
  });
  const fDrivigLicenseMedia = updatedDriverData?.fileUploadResponse
    ? updatedDriverData?.fileUploadResponse?.filter(
        (fmt) => fmt.mediaCode === "DRIVLIC",
      )[0]
    : "";
  const fDriverInsurance = updatedDriverData?.fileUploadResponse
    ? updatedDriverData?.fileUploadResponse?.filter(
        (fmt) => fmt.mediaCode === "PROOFINS",
      )[0]
    : "";

  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    defaultValues: updatedDriverData,
    resolver: yupResolver(editDriverScheme),
  });

  const handleImageUploadChange = (e, typeOfDocument) => {
    const uploadedFile = URL.createObjectURL(e.target.files[0]);
    if (typeOfDocument === "DRIVLIC") {
      setUploadedImage(uploadedFile);
      setUploadedFile(e.target.files[0]);
    } else {
      setUploadInsuranceProofImage(uploadedFile);
      setUploadInsuranceProof(e.target.files[0]);
    }
  };
  const urlToObject = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    return file;
  };
  const submitForm = async (values) => {
    const newValues = {
      ...values,
    };
    delete newValues[KEYS.PHONE_NUMBER];
    delete newValues[KEYS.COUNTRY_CODE];
    newValues[KEYS.PHONE] = {
      phoneNumber: values?.phoneNumber,
      intlDialCd: values?.countryCode,
    };
    let imageObject;
    if (!uploadedFile) imageObject = await urlToObject(uploadedImage);
    else imageObject = uploadedFile;

    let fileInfoArray = [];
    let deleteOldMedia = [];
    if (uploadedFile?.type || isDrivingLicenseRemoved) {
      fileInfoArray.push({
        name: "file0",
        mediaType: uploadedFile
          ? uploadedFile?.type === "application/pdf"
            ? "PDF"
            : uploadedFile?.type
          : "",
        mediaCode: "DRIVLIC",
        mediaObj: uploadedFile,
      });

      const fileMedialObj = updatedDriverData?.fileUploadResponse?.filter(
        (fm) => fm.mediaCode === "DRIVLIC",
      );
      if (fileMedialObj && fileMedialObj[0] && fileMedialObj[0].mediaId) {
        deleteOldMedia.push(fileMedialObj[0].mediaId);
      }
    }
    if (uploadInsuranceProof?.type || isDriverInsuranceRemoved) {
      fileInfoArray.push({
        name: "file1",
        mediaType: uploadInsuranceProof
          ? uploadInsuranceProof?.type === "application/pdf"
            ? "PDF"
            : uploadInsuranceProof?.type
          : "",
        mediaCode: "PROOFINS",
        mediaObj: uploadInsuranceProof,
      });

      const fileMedialPROOFINSObj =
        updatedDriverData?.fileUploadResponse?.filter(
          (fm) => fm.mediaCode === "PROOFINS",
        );

      if (
        fileMedialPROOFINSObj &&
        fileMedialPROOFINSObj[0] &&
        fileMedialPROOFINSObj[0].mediaId
      )
        deleteOldMedia.push(fileMedialPROOFINSObj[0].mediaId);
    }
    newValues.fileInfosArray = fileInfoArray;
    newValues.deleteOldMedia = deleteOldMedia;
    setDialogProps((prev) => ({
      ...prev,
      isOpen: true,
      handleContinue: () => {
        setIsLoading(true);
        dispatch(
          updateDriverRequest(
            updatedDriverData.userId,
            newValues,
            imageObject,
            (response) => {
              setIsLoading(false);
              if (smDown) {
                navigate(-2);
              } else {
                navigate(-1);
              }
            },
          ),
        );
      },
    }));
  };

  useEffect(() => {
    if (!stateObject?.USA?.length)
      dispatch(stateListDriverRequest({}, (response) => {}));
  }, []);

  const myRef = useRef({});

  return (
    <div
      style={{
        width: "100%",
        marginLeft: 0,
      }}
    >
      {enableNav && (
        <NavBar
          title={t("pages.editDriver.pageHeading")}
          myRef={myRef}
          enableMenu={false}
        />
      )}
      <MenuBar myRef={myRef} />
      <Box
        sx={{
          width: `${lgUp ? "75%" : "100%"}`,
          margin: "auto",
        }}
      >
        <form
          onSubmit={handleSubmit((data) => submitForm(data))}
          style={{ marginTop: "3%" }}
        >
          <Stack
            spacing={2}
            sx={{ justifyContent: "space-between", padding: 2 }}
          >
            <Controller
              name="firstName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="firstName"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text07")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                />
              )}
            ></Controller>

            <Controller
              name="middleName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="middleName"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text15")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                />
              )}
            ></Controller>
            <Controller
              name="lastName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="lastName"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text08")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                />
              )}
            ></Controller>
            <Controller
              name="userEmail"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  disabled={true}
                  name="userEmail"
                  type="email"
                  id="standard-required"
                  label={t("commonLabels.text09")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.userEmail}
                  helperText={errors.userEmail?.message}
                />
              )}
            ></Controller>
            <Grid
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
            >
              <Grid mt={"2px"}>
                <Typography fontSize={"12px"} color="grey">
                  {t("pages.editDriver.text03")}
                </Typography>
                <Controller
                  mt={1}
                  name="countryCode"
                  control={control}
                  render={({ field }) => (
                    <Select
                      renderValue={(value) =>
                        value?.length
                          ? Array.isArray(value)
                            ? value.join(", ")
                            : value
                          : t("pages.editDriver.text03")
                      }
                      sx={{
                        width: isMobileDeviceCheck() ? 80 : 100,
                        height: 40,
                        marginTop: "2px",
                      }}
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      autoWidth
                      label={t("pages.editDriver.text03")}
                      {...field}
                    >
                      {Object.keys(COUNTRY_CODE).map((item) => {
                        return (
                          <MenuItem value={item}>{COUNTRY_CODE[item]}</MenuItem>
                        );
                      })}
                    </Select>
                  )}
                ></Controller>
                <p style={{ color: "#d32f2f", fontSize: "12px" }}>
                  {errors.countryCode?.message}
                </p>
              </Grid>
              <Grid width={"70%"} display={"flex"} alignItems={"center"}>
                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="phoneNumber"
                      type="tel"
                      id="standard-required"
                      label={t("commonLabels.text10")}
                      variant="standard"
                      className="edit_field"
                      size="small"
                      margin="none"
                      sx={{
                        "& .MuiStack-root": {
                          paddingTop: "20% !important",
                        },
                      }}
                      error={!!errors.phoneNumber}
                      helperText={errors.phoneNumber?.message}
                    />
                  )}
                ></Controller>
              </Grid>
            </Grid>
            <Controller
              name="addressLine1"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="addressLine1"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text11")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.addressLine1}
                  helperText={errors.addressLine1?.message}
                />
              )}
            ></Controller>
            <Controller
              name="city"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="state"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text12")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.city}
                  helperText={errors.city?.message}
                />
              )}
            ></Controller>
            <Controller
              name="stateCode"
              control={control}
              render={({ field }) => (
                <TextField
                  select
                  {...field}
                  name="stateCode"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text13")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.stateCode}
                  helperText={errors.stateCode?.message}
                >
                  {stateObject?.USA?.map((option) => (
                    <MenuItem key={option.code} value={option.code}>
                      {option.description}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            ></Controller>
            <Controller
              name="postalCode"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  name="postalCode"
                  type="text"
                  id="standard-required"
                  label={t("commonLabels.text14")}
                  variant="standard"
                  className="edit_field"
                  size="small"
                  margin="none"
                  sx={{
                    "& .MuiStack-root": {
                      paddingTop: "20% !important",
                    },
                  }}
                  error={!!errors.zip}
                  helperText={errors.zip?.message}
                />
              )}
            ></Controller>
          </Stack>
          <div style={{ alignItems: "center", flexDirection: "row" }}>
            <div
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ListItem alignItems="center">
                <ImageListItem>
                  <img
                    alt=""
                    style={{
                      width: 60,
                      height: 60,
                      // top: 12,
                      borderRadius: 8,
                    }}
                    loading="lazy"
                    src={
                      uploadedImage
                        ? uploadedImage
                        : fDrivigLicenseMedia?.tempUrlTumbs
                          ? isDrivingLicenseRemoved
                            ? VehiclePlaceholderImage
                            : fDrivigLicenseMedia?.tempUrlTumbs
                          : VehiclePlaceholderImage
                    }
                  />
                </ImageListItem>
                <ListItemText
                  primary={
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        color="text.primary"
                        style={{
                          fontFamily: "Segoe UI",
                          fontSize: 16,
                          fontWeight: 600,
                          textAlign: "left",
                          letterSpacing: "0.5%",
                        }}
                      >
                        {t("pages.editDriver.text01")}
                      </Typography>
                    </div>
                  }
                  style={{
                    fontFamily: "Segoe UI",
                    fontSize: 16,
                    fontWeight: 600,
                    textAlign: "left",
                    letterSpacing: "0.5%",
                  }}
                  sx={{ marginLeft: 2 }}
                  secondary={
                    <React.Fragment>
                      {fDrivigLicenseMedia?.mediaUpdDate && (
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {`Uploaded on ${getDate(
                            fDrivigLicenseMedia?.mediaUpdDate,
                          )}`}
                        </Typography>
                      )}
                    </React.Fragment>
                  }
                />
              </ListItem>

              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  marginRight: 8,
                }}
              >
                <Tooltip title="Upload" arrow>
                  <IconButton
                    aria-label="upload"
                    component="label"
                    sx={{ padding: 0 }}
                  >
                    <>
                      <UploadIcon style={{ width: 40, height: 40 }} />
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(f) => handleImageUploadChange(f, "DRIVLIC")}
                        accept="image/png, image/jpeg, application/pdf"
                      />
                    </>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Remove" arrow>
                  <IconButton
                    aria-label="upload"
                    component="label"
                    onClick={() => {
                      setUploadedFile(null);
                      setUploadedImage(null);
                      setIsDrivingLicenseRemoved(true);
                    }}
                    sx={{ padding: 0 }}
                  >
                    <DeleteIcon style={{ width: 40, height: 40 }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <Divider
              variant="fullWidth"
              color="lightGray"
              style={{ width: "100%" }}
            />
          </div>
          <div
            style={{
              alignItems: "center",
              flexDirection: "row",
              marginRight: 8,
            }}
          >
            <div
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ListItem alignItems="center">
                <ImageListItem>
                  <img
                    alt=""
                    style={{
                      width: 60,
                      height: 60,
                      top: 12,
                      borderRadius: 8,
                    }}
                    loading="lazy"
                    src={
                      uploadInsuranceProofImage
                        ? uploadInsuranceProofImage
                        : fDriverInsurance?.tempUrlTumbs
                          ? isDriverInsuranceRemoved
                            ? VehiclePlaceholderImage
                            : fDriverInsurance?.tempUrlTumbs
                          : VehiclePlaceholderImage
                    }
                  />
                </ImageListItem>
                <ListItemText
                  primary={
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        color="text.primary"
                        style={{
                          fontFamily: "Segoe UI",
                          fontSize: 16,
                          fontWeight: 600,
                          textAlign: "left",
                          letterSpacing: "0.5%",
                        }}
                      >
                        {t("pages.editDriver.text02")}
                      </Typography>
                    </div>
                  }
                  style={{
                    fontFamily: "Segoe UI",
                    fontSize: 16,
                    fontWeight: 600,
                    textAlign: "left",
                    letterSpacing: "0.5%",
                  }}
                  sx={{ marginLeft: 2 }}
                  secondary={
                    <React.Fragment>
                      {fDriverInsurance?.mediaUpdDate && (
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {`Uploaded on ${getDate(
                            fDriverInsurance?.mediaUpdDate,
                          )}`}
                        </Typography>
                      )}
                    </React.Fragment>
                  }
                />
              </ListItem>

              <div style={{ flexDirection: "row", display: "flex" }}>
                <Tooltip title="Upload" arrow>
                  <IconButton
                    aria-label="upload"
                    component="label"
                    sx={{ padding: 0 }}
                  >
                    <>
                      <UploadIcon style={{ width: 40, height: 40 }} />
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(f) => handleImageUploadChange(f, "PROOFINS")}
                        accept="image/png, image/jpeg, application/pdf"
                      />
                    </>
                  </IconButton>
                </Tooltip>

                <Tooltip title="Remove" arrow>
                  <IconButton
                    aria-label="upload"
                    component="label"
                    onClick={() => {
                      setUploadInsuranceProof(null);
                      setUploadInsuranceProofImage(null);
                      setIsDriverInsuranceRemoved(true);
                    }}
                    sx={{ padding: 0 }}
                  >
                    <DeleteIcon style={{ width: 40, height: 40 }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
            <Divider
              variant="fullWidth"
              color="lightGray"
              style={{ width: "100%" }}
            />
          </div>
          <Button
            type="submit"
            variant="contained"
            alignSelf={"center"}
            disabled={isLoading || !isValid}
            style={{
              alignSelf: "center",
              width: 199,
              height: 32,
              marginLeft: 88,
              alignItems: "center",
              margin: "auto",
              marginTop: isDialog ? 20 : 50,
              marginBottom: isDialog ? 20 : "auto",
              display: "flex",
            }}
            className="update_button"
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("commonLabels.text16")}
            </Typography>
          </Button>
        </form>
      </Box>
      {dialogProps.isOpen && <ConfirmationDialog {...dialogProps} />}
    </div>
  );
};

export default EditDriver;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
